export const PALETTE = [
  "#1E5AA8", "#2E86DE", "#54A0FF", "#0B2545",
  "#27AE60", "#F39C12", "#8E44AD", "#E74C3C",
];

export const TIM_COLOR = { ROYAL: "#8E44AD", DIAMOND: "#2E86DE", Lainnya: "#6B7A90" };

export const ROLE_LABELS = {
  admin: "Administrator",
  manager: "Manager",
  sales_tl: "Sales Team Leader",
  sales: "Sales",
  rm: "Relationship Manager",
};

export const ENTRY_OPTS = {
  nama_sales: ["Ardhita", "Handy", "Detin", "Amel", "Cimetta", "Yulizar", "Adam", "Fadel", "Gio"],
  status_sekolah: [
    "New Lead", "Cold Prospect", "Prospective", "Hot Prospect",
    "New Account Sign", "Existing Account",
  ],
  tujuan_sales: ["EFT Purposed", "TeachCast Partnership Purposed"],
  kegiatan: [
    "Cold Call", "Send Proposal", "Walk-in",
    "Follow-up Meetings (non-decision makers)",
    "1st presentation (non-decision makers)",
    "Qualified Meetings (with foundation/principal/parents)",
    "Follow-up Call", "Agreement Drafting", "Agreement Sign",
    "Foundation Sign", "EFT Activation Meeting", "Lainnya",
  ],
  dilakukan_via: ["Zoom", "Onsite Meeting", "Phone Call"],
  jabatan: [
    "Kepala Yayasan", "Kepala Sekolah", "Management Yayasan",
    "Management Sekolah", "Staff Yayasan", "Staff Sekolah",
    "Guru", "Security", "Lainnya",
  ],
  produk_menarik: [
    "TeachCast Basic", "TeachCast Cambridge Essential",
    "TeachCast Cambridge Plus", "TeachCast Cambridge Premium", "EFT",
  ],
  demo_speakeng: ["Ya", "Tidak"],
};

export const ENTRY_INITIAL = {
  nama_sales: "", status_sekolah: "", nama_sekolah: "", npsn: "", alamat: "",
  nama_yayasan: "", tujuan_sales: "", kegiatan: "", kegiatan_lainnya: "",
  dilakukan_via: "", bertemu_dengan: "", jabatan: "", jabatan_lainnya: "",
  tanggal_visit: "", produk_menarik: "", demo_speakeng: "",
  respon_demo: "", respon_sekolah: "", detail_issue: "",
};
